import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Header.module.scss';

const Header = ({ children, className }) => (
  <div className={cn('container', styles.headerContent, className)}>
    {children}
  </div>
);

Header.propTypes = {
  className: PropTypes.string,
};

Header.defaultProps = {
  className: null,
};

export default Header;
